// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-sync-setup {
  padding: 40px;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 70px);
  align-items: center;
  background: #fff;
}

.review-header {
  text-align: center;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.review-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 15px 0;
}

.review-header p {
  font-size: 16px;
  color: #6b7280;
  margin: 5px 0;
}

.review-sections {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 30px;
}

.review-section {
  background: #e0e7ff;
  padding: 25px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.review-section:first-child {
  border-radius: 12px 12px 0 0;
}

.review-section:last-child {
  border-radius: 0 0 12px 12px;
  border-bottom: none;
}

.review-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 15px 0;
}

/* Connector Section */
.connector-display {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: center;
}

.platform-logo {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.platform-logo img {
  max-width: 100%;
  max-height: 100%;
}

.connector-arrow {
  color: #374151;
}

/* Direction Section */
.direction-value {
  font-size: 16px;
  color: #374151;
  font-weight: 500;
}

/* Mapping Section */
.mapping-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.view-details-btn {
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.view-details-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.mapping-table {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  overflow: hidden;
}

.mapping-headers {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  gap: 15px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.mapping-rows {
  padding: 0;
}

.mapping-row {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  gap: 15px;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  align-items: center;
}

.mapping-row:last-child {
  border-bottom: none;
}

.field-left,
.field-right {
  font-size: 14px;
  color: #4b5563;
}

.mapping-arrow {
  display: flex;
  justify-content: center;
  color: #6b7280;
}

/* Warning Section */
.warning-section {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  gap: 15px;
  margin-bottom: 40px;
}

.warning-icon {
  flex-shrink: 0;
  color: #d97706;
}

.warning-content {
  flex: 1 1;
}

.warning-content p {
  margin: 5px 0;
  font-size: 14px;
  color: #92400e;
  line-height: 1.5;
}

.warning-content p:first-child {
  font-weight: 600;
}

/* Actions Section */
.actions-section {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: auto;
  padding-top: 20px;
}

.back-button {
  padding: 12px 24px;
  border: 1px solid #d1d5db;
  background: white;
  color: #6b7280;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f3f4f6;
  color: #374151;
}

.start-syncing-button {
  padding: 12px 24px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.start-syncing-button:hover {
  background: #2563eb;
}

@media (max-width: 768px) {
  .review-sync-setup {
    padding: 20px;
  }

  .review-section {
    padding: 20px;
  }

  .connector-display {
    justify-content: center;
  }

  .mapping-headers,
  .mapping-row {
    grid-template-columns: 1fr;
    gap: 10px;
    text-align: center;
  }

  .mapping-arrow {
    transform: rotate(90deg);
  }

  .mapping-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .actions-section {
    flex-direction: column;
  }
}
.platform-logo.hubspot {
    background: #ff7a59;
}
.platform-logo.salesforce {
  background: #00a1e0;
}


.review-sync-setup .step-label{
    position: relative;
  right: 6rem;
  top: 2.3rem;

}`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/ReviewSyncSetup/ReviewSyncSetup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;IACI,mBAAmB;AACvB;AACA;EACE,mBAAmB;AACrB;;;AAGA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;;AAEb","sourcesContent":[".review-sync-setup {\n  padding: 40px;\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 70px);\n  align-items: center;\n  background: #fff;\n}\n\n.review-header {\n  text-align: center;\n  margin-bottom: 40px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.review-header h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 15px 0;\n}\n\n.review-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin: 5px 0;\n}\n\n.review-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 30px;\n}\n\n.review-section {\n  background: #e0e7ff;\n  padding: 25px 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.review-section:first-child {\n  border-radius: 12px 12px 0 0;\n}\n\n.review-section:last-child {\n  border-radius: 0 0 12px 12px;\n  border-bottom: none;\n}\n\n.review-section h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 15px 0;\n}\n\n/* Connector Section */\n.connector-display {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  justify-content: center;\n}\n\n.platform-logo {\n  width: 60px;\n  height: 60px;\n  background: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.platform-logo img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.connector-arrow {\n  color: #374151;\n}\n\n/* Direction Section */\n.direction-value {\n  font-size: 16px;\n  color: #374151;\n  font-weight: 500;\n}\n\n/* Mapping Section */\n.mapping-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.view-details-btn {\n  background: white;\n  border: 1px solid #d1d5db;\n  color: #374151;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.view-details-btn:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.mapping-table {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.mapping-headers {\n  display: grid;\n  grid-template-columns: 1fr 40px 1fr;\n  gap: 15px;\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.7);\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.mapping-rows {\n  padding: 0;\n}\n\n.mapping-row {\n  display: grid;\n  grid-template-columns: 1fr 40px 1fr;\n  gap: 15px;\n  padding: 12px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  align-items: center;\n}\n\n.mapping-row:last-child {\n  border-bottom: none;\n}\n\n.field-left,\n.field-right {\n  font-size: 14px;\n  color: #4b5563;\n}\n\n.mapping-arrow {\n  display: flex;\n  justify-content: center;\n  color: #6b7280;\n}\n\n/* Warning Section */\n.warning-section {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  gap: 15px;\n  margin-bottom: 40px;\n}\n\n.warning-icon {\n  flex-shrink: 0;\n  color: #d97706;\n}\n\n.warning-content {\n  flex: 1;\n}\n\n.warning-content p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #92400e;\n  line-height: 1.5;\n}\n\n.warning-content p:first-child {\n  font-weight: 600;\n}\n\n/* Actions Section */\n.actions-section {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: auto;\n  padding-top: 20px;\n}\n\n.back-button {\n  padding: 12px 24px;\n  border: 1px solid #d1d5db;\n  background: white;\n  color: #6b7280;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.start-syncing-button {\n  padding: 12px 24px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.start-syncing-button:hover {\n  background: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .review-sync-setup {\n    padding: 20px;\n  }\n\n  .review-section {\n    padding: 20px;\n  }\n\n  .connector-display {\n    justify-content: center;\n  }\n\n  .mapping-headers,\n  .mapping-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    text-align: center;\n  }\n\n  .mapping-arrow {\n    transform: rotate(90deg);\n  }\n\n  .mapping-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n}\n.platform-logo.hubspot {\n    background: #ff7a59;\n}\n.platform-logo.salesforce {\n  background: #00a1e0;\n}\n\n\n.review-sync-setup .step-label{\n    position: relative;\n  right: 6rem;\n  top: 2.3rem;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
